import cx from "../../utils/cx.ts";
import { Maybe } from "../../utils/types/maybe.ts";

type Props = {
  message: Maybe<string>;
  className?: string;
};

export default function ErrorLabel({ message, className = "" }: Props) {
  return (
    message && (
      <p className={cx(className, "text-sm font-normal text-red-500 block")}>
        {message}
      </p>
    )
  );
}
